<template>
  <!-- prettier-ignore -->
  <div :class="classes">
    <div class="screen-header"><slot name="header" /></div>
    <div class="screen-content"><slot /></div>
    <div class="screen-footer"><slot name="footer" /></div>
  </div>
</template>

<script setup>
import { computed, useSlots } from 'vue'

const slots = useSlots()

// props
const props = defineProps({
  aide: {
    type: Boolean,
    default: false,
  },
  config: {
    type: Object,
    default: () => {},
  },
})

// Computed
const light = computed(() => {
  return props.config?.header?.light === true
})

const classes = computed(() => {
  return {
    screen: true,
    'screen--light': light.value && slots?.header,
    'screen--aide': props.aide,
  }
})
</script>

<style name="mobile" scoped>
.screen {
  &-header {
    &:empty {
      display: none;
    }
  }

  &-content {
    width: 100%;
    padding: 0 0 10px 0;
  }

  &-footer {
    &:empty {
      display: none;
    }
  }

  &--light {
    .screen {
      &-header {
        background-color: var(--c-primary-neutral-3);
        padding-top: 15px;
      }
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .screen {
    &-header {
      width: 100%;
    }

    &-content {
      min-width: 768px;
      max-width: 960px;
      margin: 0 auto;
      padding: 0 0 30px 0;
    }

    &-footer {
      width: 100%;
    }

    &--aide {
      .screen-content,
      .screen-header,
      .screen-footer {
        min-width: auto;
        max-width: 620px;
        margin: 0;
      }
    }
  }
}
</style>
